/* tslint:disable */

export class ValueListItem {
		Id: number;
		ValueListId: number;
		Value: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ValueListItem.ts